"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const mobx_react_1 = require("mobx-react");
const react_loader_1 = __importDefault(require("react-loader"));
const Defaults_1 = require("../../common/Defaults");
const hui_1 = require("@mit/hui");
const react_toastify_1 = require("react-toastify");
const moment_1 = __importDefault(require("moment"));
;
const ChangeHoldStatusComponent = ({ person, show, onClose, peopleStore, holds, covidNav, roles }) => {
    const isClearedStatus = () => {
        if (holds && holds.newStatus && holds.newStatus.text === 'Cleared') {
            return true;
        }
        else {
            return false;
        }
    };
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [isDisabled, setIsDisabled] = (0, react_1.useState)(false);
    const [holdTypeSelected, setHoldTypeSelected] = (0, react_1.useState)("New");
    const [agreedToCleared, setAgreedToCleared] = (0, react_1.useState)(false);
    const [clearDate, setClearDate] = (0, react_1.useState)();
    const [clearTime, setClearTime] = (0, react_1.useState)();
    const [exemptFromTesting, setExemptFromTesting] = (0, react_1.useState)(false);
    const getNewStatus = (value) => {
        if (holds && holds.statuses && value) {
            let newStatus = holds.statuses.find((x) => { return x.text === (value && value.text ? value.text : value); });
            return newStatus;
        }
    };
    const setNewStatus = (value) => {
        holds.newStatus = getNewStatus(value);
    };
    const setDateTime = () => {
        let now = (person && person.status === 'Scheduled To Clear') ? new Date(person.scheduled_time) : new Date();
        var dateNow = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
        let timeNow = now.getHours() + ":" + now.getMinutes();
        setClearDate(dateNow);
        setClearTime(timeNow);
    };
    //component is already created, so you need to check whenever holds.newStatus!.text changes to see if isDisabled is true
    (0, react_1.useEffect)(() => {
        setIsDisabled(isClearedStatus() && !agreedToCleared);
        setHoldTypeSelected(holds && holds.newStatus ? holds.newStatus.text : person === null || person === void 0 ? void 0 : person.status);
    }, [holds.newStatus, agreedToCleared]);
    (0, react_1.useEffect)(() => {
        if (show) {
            setIsDisabled(isClearedStatus() && !agreedToCleared);
            setDateTime();
            setHoldTypeSelected(holds && holds.newStatus ? holds.newStatus.text : person === null || person === void 0 ? void 0 : person.status);
            setNewStatus(holds && holds.newStatus ? holds.newStatus.text : person === null || person === void 0 ? void 0 : person.status);
        }
    }, [show]);
    const handleClose = () => {
        holds.showUpdateStatusModal = false;
        holds.newStatus = undefined;
        setIsLoading(false);
        setIsDisabled(false);
        setAgreedToCleared(false);
        setExemptFromTesting(false);
        setClearDate(undefined);
        setClearTime(undefined);
        onClose();
    };
    const submitAndClose = () => {
        setIsLoading(true);
        let d = new Date(`${clearDate} ${clearTime}`);
        let date = (0, moment_1.default)(d).toISOString(true);
        holds.showUpdateStatusModal = false;
        MedicalApi_1.default.patchStatus(person.hold_guid, holds.newStatus.id, exemptFromTesting, date, true).then((response) => {
            setIsLoading(false);
            if (person) {
                MedicalApi_1.default.fetchPersonMedicalHolds(person.mit_id).then((resp) => {
                    holds.personHolds = resp.items ? resp.items : [];
                });
            }
            if (peopleStore) {
                MedicalApi_1.default.fetchAllHolds().then((response) => {
                    if (response.items) {
                        peopleStore.setFollowUpList(response.items);
                    }
                });
            }
            if (response.error) {
                react_toastify_1.toast.error('Could not update status', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            handleClose();
        });
    };
    const replaceAll = (base, search, replaceWith) => {
        return base.split(search).join(replaceWith);
    };
    const getName = (name) => {
        if (!name)
            return "";
        const nameArr = name.split(',');
        return nameArr.length === 2 ? `${nameArr[1]} ${nameArr[0]}` : nameArr.length === 1 ? nameArr[0] : name;
    };
    const renderClearedConfirmationText = (confText, name) => {
        return replaceAll(confText, '[name]', `${getName(name)}`);
    };
    const renderExemptText = (confText) => {
        return (confText) ? confText : "Exempt from testing for 90 days";
    };
    let mainActionButtonEnabled = ((holds && holds.newStatus && holds.newStatus.text === 'Cleared') || (holds && holds.newStatus && holds.newStatus.text === 'Scheduled To Clear'))
        ? agreedToCleared : true;
    const defaultButtonData = [
        { icon: '', text: 'Submit', type: hui_1.ButtonType.Primary, onClick: () => { submitAndClose(); }, state: (roles === null || roles === void 0 ? void 0 : roles.statusDisabled()) ? hui_1.ButtonState.Disabled : mainActionButtonEnabled ? hui_1.ButtonState.Enabled : hui_1.ButtonState.Disabled },
        { icon: '', text: 'Cancel', type: hui_1.ButtonType.Primary | hui_1.ButtonType.Ghost, onClick: () => { handleClose(); }, state: hui_1.ButtonState.Enabled },
    ];
    const getDropDownItems = () => {
        let dropdownData = [];
        if (holds && holds.statuses) {
            // console.log("holds.statuses", holds.statuses)
            holds.statuses.map((status) => {
                // console.log("holds.status", status)
                dropdownData.push({ text: status.text, icon: "", id: status.id });
            });
            // console.log("holds.statuses dropdownData", dropdownData)
        }
        return dropdownData;
    };
    const dislay_name = person && person.display_name ? `${person.display_name.split(', ')[1]} ${person.display_name.split(', ')[0]}` : '';
    const cleared_text = covidNav.texts['medical.clear.attestation'].replaceAll('[name]', dislay_name);
    return ((0, jsx_runtime_1.jsx)(hui_1.Drawer, { contentAriaLabel: `Change Hold Status`, header: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: "Change Hold Status", type: hui_1.TextType.Heading3 }) }), type: hui_1.DrawerType.Right, themedColor: "medical", footer: defaultButtonData, contents: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(react_loader_1.default, Object.assign({ loaded: !isLoading, options: Object.assign(Object.assign({}, Defaults_1.mediumLoaderOptions), { color: '#000000' }) }, { children: [(0, jsx_runtime_1.jsx)("p", { children: "You will be changing the hold status to" }), (0, jsx_runtime_1.jsx)(hui_1.Dropdown, { id: "change_hold_status", disabled: roles === null || roles === void 0 ? void 0 : roles.statusDisabled(), text: "", dropdownItems: getDropDownItems(), name: "dropdownStatus", value: person === null || person === void 0 ? void 0 : person.status, onChange: (value) => setNewStatus(value) }), (holdTypeSelected === 'Cleared' || holdTypeSelected === 'Scheduled To Clear') &&
                        (0, jsx_runtime_1.jsxs)("div", { children: [holdTypeSelected === 'Scheduled To Clear' &&
                                    (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'flex mt-3' }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'row' }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'col-6' }, { children: (0, jsx_runtime_1.jsx)(hui_1.CalendarInput, { clearable: false, id: "schedule clear", onChange: (val) => { console.log(val); setClearDate(val); }, placeholder: "Please select a date", value: clearDate }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'col-6' }, { children: (0, jsx_runtime_1.jsx)(hui_1.TimePicker, { value: clearTime, onChange: (val) => { console.log(val); setClearTime(val); } }) }))] })) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'flex ml-4 mt-3' }, { children: [(0, jsx_runtime_1.jsx)("input", { id: 'cleared-checkbox', className: 'form-check-input', type: 'checkbox', checked: agreedToCleared, onChange: () => {
                                                setAgreedToCleared(!agreedToCleared);
                                            } }), (0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: 'cleared-checkbox', className: "form-check-label" }, { children: renderClearedConfirmationText(cleared_text, holds.personName) }))] })), (person === null || person === void 0 ? void 0 : person.reason) === 'Positive Medical Test' ?
                                    (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'flex ml-4 mt-3' }, { children: [(0, jsx_runtime_1.jsx)("input", { id: 'exempt-checkbox', className: 'form-check-input', type: 'checkbox', checked: exemptFromTesting, onChange: () => {
                                                    setExemptFromTesting(!exemptFromTesting);
                                                } }), (0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: 'exempt-checkbox', className: "form-check-label" }, { children: renderExemptText(covidNav.texts['medical.clear.exempt']) }))] })) :
                                    null] })] })) }), show: show || false, onClose: handleClose, size: hui_1.DrawerSize.Small }));
};
const ChangeHoldStatus = (0, mobx_react_1.inject)('peopleStore', 'holds', 'roles', 'covidNav')((0, mobx_react_1.observer)(ChangeHoldStatusComponent));
exports.default = ChangeHoldStatus;
